import { browserName, isChrome, isMobile, mobileModel } from 'react-device-detect'

export function isSafari() {
  return /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
}

export function isIOS() {
  return (
    [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod',
      'MacIntel',
    ].includes(navigator.platform) ||
    // iPad on iOS 13 detection
    (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
  )
}

export function isHuawei() {
  const userAgent = navigator.userAgent || navigator.vendor
  return /huawei/i.test(userAgent)
}

export function getDeviceInfo() {
  let type = 1
  if (isMobile) {
    type = 2
  }
  return {
    browserName,
    mobileModel,
    userAgent: navigator.userAgent,
    type,
  }
}

export function isInsideFacebook() {
  // @ts-expect-error
  const ua = navigator.userAgent || navigator.vendor || window.opera
  return (ua.indexOf("FBAN") > -1) || (ua.indexOf("FBAV") > -1)
}

export function isCaptureSupported() {
  if (isInsideFacebook()) return false
  return isChrome || isSafari()
}

export function isPWA() {
  // Check for standalone display mode (most reliable for most browsers)
  if (window.matchMedia('(display-mode: standalone)').matches) {
    return true
  }
  
  // Check for minimal-ui or fullscreen display modes (also PWA indicators)
  if (
    window.matchMedia('(display-mode: minimal-ui)').matches ||
    window.matchMedia('(display-mode: fullscreen)').matches
  ) {
    return true
  }
  
  // iOS Safari specific check
  if (
    typeof window.navigator !== 'undefined' &&
    (window.navigator as any).standalone === true
  ) {
    return true
  }
  
  return false
}
